import ReactGA from 'react-ga'
import {
  EVENT_NOTES
} from './categories'

export const recordNoteCreated = (templateId, voiceTriggered = false) => {
  ReactGA.event({
    category: EVENT_NOTES,
    action: 'Created',
    label: templateId,
    nonInteraction: voiceTriggered
  })
}

export const recordNoteUpdated = (status) => {
  ReactGA.event({
    category: EVENT_NOTES,
    action: 'Updated',
    label: status
  })
}

export const setUserId = (userId) => {
  ReactGA.set({ userId: userId })
}
